import './CardContent.3c904e26e58f5c1a1c2a57aabdd30d0e.css';
export default {"cardContent":"_cardContent_3fqdo_1"};